/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {AbstractField} from '../abstract-field';
import {EmpZoneDependency} from "@gp/shared/form-generator/form-generator.interfaces";

/**
 * A number type of field for numerical values (integer, floats, etc.).
 */
@Component({
  selector: 'gp-form-field-integer',
  template: `
    <number-input [type]="'integer'"
                  [attr.test-id]="descriptor.zoneID"
                  [formControl]="control"
                  [(ngModel)]="value.value"
                  [validOnPristine]="false"
                  (focus)="onFocus()"
                  (blur)="onBlur()"
                  [readOnly]="readOnly">
    </number-input>
  `,
  styleUrls: ['./integer-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntegerFieldComponent extends AbstractField implements OnInit {

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.bindDependencyTriggered();
  }

  protected afterDependencyHandled(_dependency: EmpZoneDependency) {
    this.cd.markForCheck();
  }

}
